import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SnackBarService } from '@cbuild/controls';
import { FormStateControl, splitFileUrl } from '@cbuild/shared';
import { take } from 'rxjs';
import { ModuleTypeEnum } from 'src/app/account-settings/communication-settings/communication-grid/moduleType.enum';
import { CallCenterService } from '../../call-center.service';
import { TemplateData, TemplateTypes } from '../../models/template-types-model';

@Component({
  selector: 'cs-email-communication',
  standalone: false,
  templateUrl: './email-communication.component.html',
  styleUrls: ['./email-communication.component.scss']
})
export class EmailCommunicationComponent extends FormStateControl
  implements OnInit {
  @Input()
  public form: FormGroup;
  public templateTypes: Array<TemplateTypes> | undefined;
  public moduleTypeEnum = ModuleTypeEnum;
  public isLoading: boolean;
  public templateData: TemplateData;

  constructor(
    private fb: FormBuilder,
    private service: CallCenterService,
    private renderer: Renderer2,
    private el: ElementRef,
    private snackbar: SnackBarService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.service
      .getEmailTemplates(this.moduleTypeEnum.SALES)
      .pipe(take(1))
      .subscribe(res => {
        this.templateTypes = res;
      });
    const group = this.form.get('emailCommunication');
    if (!group) {
      this.infoForm = this.initializeInfoForm();
      this.form.addControl('emailCommunication', this.infoForm);
    } else {
      this.infoForm = this.form.get('emailCommunication') as FormGroup;
      this.onTemplateChange();
    }
  }

  private initializeInfoForm(): FormGroup {
    return this.fb.group({
      templateType: [],
      moduleType: this.moduleTypeEnum.SALES
    });
  }

  public onTemplateChange(): void {
    const templateTypeValue = this.getControl('templateType').value;
    const propertyId = this.form.get('propertyId')?.value;
    if (propertyId) {
      this.service
        .getEmailTemplateData(propertyId, templateTypeValue)
        .pipe(take(1))
        .subscribe(res => {
          this.isLoading = true;
          this.templateData = res;
          this.loadPreview();
        });
    } else {
      this.getControl('templateType').setValue(null);
      this.snackbar.open('Please select property', {
        type: 'error'
      });
    }
  }

  private loadPreview(): void {
    const request = new XMLHttpRequest();
    const filePath = splitFileUrl(this.templateData.templatePath);
    if (filePath) {
      this.isLoading = true;
      request.open('GET', filePath, true);
      request.send(null);
      request.onreadystatechange = () => {
        if (request.readyState === 4 && request.status === 200) {
          const type = request.getResponseHeader('Content-Type');
          if (type?.indexOf('text') !== 1) {
            const element = this.el.nativeElement.querySelector(
              '.parent div span'
            );
            this.renderer.setProperty(
              element,
              'innerHTML',
              request.responseText
            );
            this.isLoading = false;
          }
        }
      };
    }
  }
}
